import { render } from "./RegisterProductFactor.vue?vue&type=template&id=7b3c9ce4"
import script from "./RegisterProductFactor.vue?vue&type=script&lang=js"
export * from "./RegisterProductFactor.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__